<template>
  <router-view />
</template>

<script>
import { inicializar as inicializarTracker } from '@/utils/lpTracker';

export default {
  name: 'App',

  mounted() {
    // Inicializa imediatamente — o FB Pixel cria o stub fbq() de forma síncrona
    // e carrega fbevents.js em background. Eventos disparados antes do load
    // ficam na fila e são processados automaticamente.
    this.setFacebookPixelId();
    this.setGoogleTagId();
    this.setParameters();
    this.inicializarTracking();
  },

  methods: {
    setParameters() {
      const urlParams = new URLSearchParams(window.location.search);
      const planId = urlParams.get('planId');
      const checkout = urlParams.get('checkout');
      const hideWhatsapp = urlParams.get('hw');

      this.$store.commit('setCheckout', checkout);
      this.$store.commit('setHideWhatsapp', hideWhatsapp);

      // ── Cache de planos (7 dias) ─────────────────────────────────────
      const PLANOS_KEY  = 'zm-planos-ts';
      const SEVEN_DAYS  = 7 * 24 * 60 * 60 * 1000;
      const hasParam    = urlParams.has('planos');

      if (hasParam) {
        // Viu os planos agora — (re)inicia o cache
        localStorage.setItem(PLANOS_KEY, Date.now().toString());
      }

      const cached    = localStorage.getItem(PLANOS_KEY);
      const cacheAge  = cached ? Date.now() - parseInt(cached, 10) : Infinity;
      const cacheOk   = cacheAge < SEVEN_DAYS;

      if (!cacheOk && cached) {
        // Cache expirado — limpa
        localStorage.removeItem(PLANOS_KEY);
      }

      this.$store.commit('setShowPlanos', hasParam || cacheOk);
      // ────────────────────────────────────────────────────────────────

      if (planId == 9900) {
        this.$store.commit('setPlan', {
          price: 99,
          checkout: 'https://mpago.la/2yVBof5',
        });
        return;
      }

      if (planId == 7900) {
        this.$store.commit('setPlan', {
          price: 79,
          checkout: 'https://mpago.la/1KofqY4',
        });
        return;
      }

      this.$store.commit('setPlan', {
        price: 0,
        checkout: null,
      });
    },

    inicializarTracking() {
      const urlParams = this.$store.state.urlParams;
      const primeiroPath = this.$route ? this.$route.path : '/';
      inicializarTracker(urlParams, primeiroPath);
    },

    setFacebookPixelId() {
      const pxl = this.$store.state.urlParams.pxl;

      const facebookPixelId = pxl || '414269820321293';

      if (document.querySelector('#facebook-pixel-id')) {
        return;
      }

      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = false;
      s.id = 'facebook-pixel-id';
      s.innerText = '!function(f,b,e,v,n,t,s)' +
        '{if(f.fbq)return;n=f.fbq=function(){n.callMethod?' +
        'n.callMethod.apply(n,arguments):n.queue.push(arguments)};' +
        'if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";' +
        'n.queue=[];t=b.createElement(e);t.async=!0;' +
        't.src=v;s=b.getElementsByTagName(e)[0];' +
        's.parentNode.insertBefore(t,s)}(window, document,"script",' +
        '"https://connect.facebook.net/en_US/fbevents.js");' +
        `fbq("init", "${facebookPixelId}");` +
        'fbq("track", "PageView");';

      document.body.appendChild(s);
    },

    setGoogleTagId() {
      const googleTagId = 'GTM-5ZHXBNS9';

      if (document.querySelector('#google-tag-id')) {
        return;
      }

      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.id = 'google-tag-script';
      s.src = `https://www.googletagmanager.com/gtag/js?id=${googleTagId}`;
      document.body.appendChild(s);

      const s2 = document.createElement('script');
      s2.type = 'text/javascript';
      s2.defer = true;
      s2.id = 'google-tag-id';
      s2.innerText = 'window.dataLayer = window.dataLayer || [];' +
        'function gtag(){dataLayer.push(arguments);}' +
        "gtag('js', new Date());" +
        // send_page_view: false — controlamos os page views via router.afterEach
        `gtag('config', '${googleTagId}', { send_page_view: false });`;
      document.body.appendChild(s2);
    },
  }
};
</script>

<style scoped>
  .v-application {
    font-family: "Poppins", Arial, sans-serif !important;
  }
</style>

<style>
  /* Fonte global — aplicada a todas as páginas (Home + funil) */
  html, body {
    font-family: "Poppins", Arial, sans-serif;
    overflow-x: hidden;
    max-width: 100vw;
  }

  /* Dark theme variables (default) */
  .v-application {
    --text-primary: #ffffff;
    --text-secondary: #dddddd;
    --text-muted: #bfbfbf;
    --text-hint: #888888;
    --card-bg: #181818;
    --card-border: #404040;
    --btn-icon-bg: #262626;
    --chip-bg: #292929;
    --page-bg: #000000;
  }

  /* Light theme overrides */
  .v-application.theme--light {
    --text-primary: #1a1a1a;
    --text-secondary: #444444;
    --text-muted: #666666;
    --text-hint: #777777;
    --card-bg: #ffffff;
    --card-border: #dddddd;
    --btn-icon-bg: #e0e0e0;
    --chip-bg: #eeeeee;
    --page-bg: #f5f5f5;
    --footer-bg: #1a1a1a;
    --brde-img-bg: #1a1a1a;
  }

  /* Dark theme footer/brde vars */
  .v-application.theme--dark {
    --footer-bg: #000000;
    --brde-img-bg: transparent;
  }
</style>
